import { render, staticRenderFns } from "./orderAddress.vue?vue&type=template&id=7e66a13f&scoped=true&"
import script from "./orderAddress.vue?vue&type=script&lang=js&"
export * from "./orderAddress.vue?vue&type=script&lang=js&"
import style0 from "./orderAddress.vue?vue&type=style&index=0&id=7e66a13f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66a13f",
  null
  
)

export default component.exports